import { BONUS_BANNER_ITEM_VIEW } from './types';

export const triggerBonusBannerItemIsViewed = (bonusItem, instanceType) => ({
  type: BONUS_BANNER_ITEM_VIEW,
  bonusItem,
  instanceType,
});
